var map = {
	"./1.png": "6c2a",
	"./10.png": "142b",
	"./2.png": "afd0",
	"./3.png": "69e3",
	"./4.png": "aef8",
	"./5.png": "fd27",
	"./6.png": "9c18",
	"./7.png": "b18a",
	"./8.png": "d8b5",
	"./9.png": "14e1",
	"./title.png": "4d00",
	"./title2.png": "95ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ffd";